import script from "./DatasetCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetCreate.vue?vue&type=script&setup=true&lang=js"

import "./DatasetCreate.vue?vue&type=style&index=0&id=0c54e093&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c54e093"]])

export default __exports__